import { default as LocalStorage } from 'i18next-localstorage-backend';
import { DateKit } from '@team/date';
import { Transformer } from '@team/transformer';
import { InstanceFactoryOptions } from './types';
import { PREFIX, PREFIX_SEPARATOR } from './const';

export const createInstance = ({
  projectName,
  expirationTime = DateKit.MS_IN_DAY,
}: InstanceFactoryOptions) =>
  new LocalStorage(null, {
    expirationTime,
    store: Transformer.transformOrNull(window, (global) => global.localStorage),
    prefix: [PREFIX, projectName].join(PREFIX_SEPARATOR) + PREFIX_SEPARATOR,
  });
